import { useEffect, useState } from "react";
import React from 'react';
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
import { Link } from "react-router-dom";
import { getFaculty } from "../Service/Api";
const Faculty = () => {
    useEffect(() => {
        document.title = 'Faculty -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]); 
    useEffect(() => {
        const fetchData = async () => {
            try {
                const readingData = await getFaculty(); 
                if (Array.isArray(readingData)) { 
                    const sortedData = readingData.sort((a, b) => {
                        return parseInt(a.order) - parseInt(b.order);
                    });

                    setData(sortedData);
                    setFilteredData(sortedData); // Initially display all sorted data
                } else {
                    console.error('Error: readingData is not an array');
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Faculty </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>Academic</li>
                            <li>|</li>
                            <li> Faculty </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                    <div className="table-responsive innertable">
                    <table className="table">
                        <tbody>
                            <tr>
                                <th> S. No. </th>
                                <th>Name</th>
                                <th>Designation</th>
                               
                            </tr>
                            {filteredData.length > 0 ? (
                                            filteredData.map((item, index) => (
                             <tr>
                                <td>{index+1}</td>
                                <td>{item.name}</td>
                                <td>{item.designation}</td>
                               
                            </tr> 
                            ))
                            ) : (
                                <tr>
                                <td>1</td>
                                <td>Name</td>
                                <td>Designation</td>
                              
                            </tr> 
                            )}
                        </tbody>
                    </table>
                </div>
                    </div>
                </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default Faculty